/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyRepresentation
 */
export interface CompanyRepresentation {
    /**
     * 
     * @type {string}
     * @memberof CompanyRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyRepresentation
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyRepresentation
     */
    heroImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyRepresentation
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyRepresentation
     */
    license?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyRepresentation
     */
    portfolioKey: string;
}

/**
 * Check if a given object implements the CompanyRepresentation interface.
 */
export function instanceOfCompanyRepresentation(value: object): value is CompanyRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('portfolioKey' in value) || value['portfolioKey'] === undefined) return false;
    return true;
}

export function CompanyRepresentationFromJSON(json: any): CompanyRepresentation {
    return CompanyRepresentationFromJSONTyped(json, false);
}

export function CompanyRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'heroImage': json['heroImage'] == null ? undefined : json['heroImage'],
        'color': json['color'] == null ? undefined : json['color'],
        'license': json['license'] == null ? undefined : json['license'],
        'portfolioKey': json['portfolioKey'],
    };
}

export function CompanyRepresentationToJSON(json: any): CompanyRepresentation {
    return CompanyRepresentationToJSONTyped(json, false);
}

export function CompanyRepresentationToJSONTyped(value?: CompanyRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'logo': value['logo'],
        'heroImage': value['heroImage'],
        'color': value['color'],
        'license': value['license'],
        'portfolioKey': value['portfolioKey'],
    };
}

